import * as angular from "angular";
import {IController, IQService, IWindowService} from "angular";
import * as _ from "lodash";

export class DriverImageDisplayCtrl implements IController {

  imageUrl: string;
  isCar: boolean;

  private isImage: boolean;

  constructor(public $window: IWindowService, public $q: IQService, public $log) {
  }

  $onChanges(changes) {
    if (changes.imageUrl) {
      this.isImageTest(this.imageUrl)
        .then((isImage) => {
          this.isImage = _.isEqual(isImage, true);
        })
        .catch((error) => {
          this.$log.error('Failed to test image URL at ' +
            'driverImageDisplay@watch(imageUrl) \n' + error)
        })
    }
  };

  goToImage() {
    if (!_.isUndefined(this.imageUrl)) {
      this.$window.open(this.imageUrl);
    }
  }

  private isImageTest(src) {
    return new Promise((resolve, reject) => {
      const image = new Image();
      image.onerror = () => {
        resolve(false)
      };
      image.onload = () => {
        resolve(true)
      };
      image.src = src;
    });
  }
}

angular
  .module('bringoz.admin.accounts')
  .component('driverImageDisplay', {
    bindings: {
      imageUrl: '<',
      isCar: '<?'
    },
    template: require('./driver-image-display.html').default,
    controller: DriverImageDisplayCtrl
  });
